import getChartColorsArray from "components/Common/ChartsDynamicColor";
import React from "react"
import ReactApexChart from "react-apexcharts"
import { useNavigate } from "react-router-dom";
import { Row } from "reactstrap";
import { routes } from "routes/path";

const OtherTaskPieChart = ({ dataColors, Key, Value, userFilter, dateFilter }) => {
  const PieApexChartColors = getChartColorsArray(dataColors);
  const navigate = useNavigate()

  const handleDataPointSelection = (event, chartContext, config) => {
    const index = config?.dataPointIndex;
    const label = Key[index];
    setTimeout(() => {
      navigate(routes.task, {
        state: {
          status: label == "Discard" ? 4 : label == "Done" ? 3 : label == "In-Progress" ? 2 : label == "Assigned" ? 1 : 0,
          userFilter: userFilter,
          dateFilter: dateFilter,
        },
      });
    }, 0);
  };

  const series = Value
  const options = {
    chart: {
      height: 320,
      type: 'pie',
      events: {
        dataPointSelection: handleDataPointSelection
      }
    },
    series: Value,
    labels: Key,
    colors: PieApexChartColors,
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      verticalAlign: 'middle',
      floating: false,
      fontSize: '14px',
      offsetX: 0,
    },
    responsive: [{
      breakpoint: 600,
      options: {
        chart: {
          height: 240
        },
        legend: {
          show: false
        },
      }
    }]
  }

  return (
    <>
      {((Value[0] != 0 || Value[1] != 0)) ?
        <Row>
          < ReactApexChart options={options} series={series} type="pie" height="400" />
        </Row>
        :
        <Row style={{ display: "flex", justifyContent: "center", alignContent: "center", textAlign: "center", fontSize: "15px", fontWeight: "500", marginTop: "20px" }}>
          No Record Found
        </Row>
      }
    </>
  )
}

export default OtherTaskPieChart
